import { Route } from '@angular/router';

export const googleProfileRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'about',
  },
  {
    path: 'about',
    loadChildren: () => import('@rma/dashboard/google/about'),
  },
  {
    path: 'connect',
    loadChildren: () => import('@rma/dashboard/google/connect'),
  },
  {
    path: 'google-reviews',
    loadChildren: () => import('@rma/dashboard/google/google-reviews'),
  },
];
